import { Component, OnInit, Input } from '@angular/core';

import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { TranslateService } from 'ng2-translate';

import { ProjectsService } from '../../services/projects.service';
import { IssuesService } from '../../../issues/services/issues.service';
import { AlertManagerService } from '../../../../shared/services/alert-manager.service';

import { Version } from '../../../../modules/models/version';
import { WorkConstants } from '../../work.const';
import { BaseChartDirective } from 'ng2-charts/ng2-charts';

@Component({
  selector: 'app-project-issues',
  templateUrl: './project-issues.component.html',
  styleUrls: ['./project-issues.component.css']
})
export class ProjectIssuesComponent implements OnInit {

  @Input() projectId: number;

  //Issue 
  issuePageId: number = 1;
  issuePerPage: number = 0;
  issueCount: number = 0;
  issuePageCount: number = 1;
  issueId: number;
  isShowView: any;

  issues: Array<any> = [];
  workConstants: any = WorkConstants;

  isShowIssueCreater: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private projectsService: ProjectsService,
    private alertService: AlertManagerService,
    private translate: TranslateService,
    private issuesService: IssuesService
  ) { }

  ngOnInit() {
    this.getIssuesForProject(this.issuePageId);
  }

  /**
   * kauhsalya
   * 2017-08-04
   * get issue list
   * @param issuePageId 
   */
  getIssuesForProject(issuePageId) {
    this.isShowIssueCreater = false;
    if (!issuePageId) {
      issuePageId = this.issuePageId;
    }
    this.issuesService.getIssuesForProject(this.projectId, issuePageId).subscribe(
      issue => {
        if (issue.data && issue.data.data) {
          this.issues = issue.data.data;
          this.issuePageId = issue.data.current_page
          this.issueCount = issue.data.total
          this.issuePageCount = issue.data.last_page
          this.issuePerPage = issue.data.per_page
        };
        this.scrollThePage();
      }
    );
  }

  /**
   * kaushalya
   * 2017-08-04
   * change the issue list according to page
   * @param event 
   */
  issuePageChanged(event) {
    this.getIssuesForProject(event);
  }

  openIssueCreater(issue?: any, isShowView?: any) {
    this.issueId = issue ? issue.id : null;
    this.isShowView = isShowView ? isShowView : false;
    this.isShowIssueCreater = true;
  }

  closeIssueCreater() {
    this.isShowIssueCreater = false;
    this.getIssuesForProject(this.issuePageId);
  }

  /**
   * kauhslya
   * 2017-08-14
   * scroll The Page
   * @param event
  //  */
  scrollThePage() {
    window.scrollTo(0, 0);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/work/components/project-issues/project-issues.component.ts